import { Plus } from 'lucide-react';
import { m } from 'motion/react';
import { cn } from '@/lib/cn';

/** Botão flutuante "+" — abre o seletor de tipo de lançamento (M3). */
export function Fab({
  onClick,
  className,
  size = 'md',
  tone = 'primary',
}: {
  /** Recebe o rect do botão para ancorar o popover (desktop). */
  onClick?: (anchor: DOMRect) => void;
  className?: string;
  size?: 'md' | 'lg';
  tone?: 'primary' | 'cards';
}) {
  return (
    <m.button
      type="button"
      onClick={(e) => onClick?.(e.currentTarget.getBoundingClientRect())}
      aria-label="Novo lançamento"
      whileTap={{ scale: 0.92 }}
      className={cn(
        'grid place-items-center rounded-full text-white shadow-fab transition-colors',
        tone === 'cards' ? 'bg-cards hover:bg-cards/90' : 'bg-primary hover:bg-primary-hover',
        size === 'lg' ? 'size-14' : 'size-12',
        className,
      )}
    >
      <Plus className={size === 'lg' ? 'size-7' : 'size-6'} />
    </m.button>
  );
}
